// frontend/src/components/Dashboard/DataTable.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

const DataTable = ({
  columns,
  data,
  onSort,
  sortField: externalSortField,
  sortDirection: externalSortDirection,
  rowClassName,
  emptyMessage = "No data available",
  defaultSortField = null,
  defaultSortDirection = "asc",
}) => {
  const [internalSortField, setInternalSortField] = useState(defaultSortField);
  const [internalSortDirection, setInternalSortDirection] =
    useState(defaultSortDirection);

  const sortField = externalSortField ?? internalSortField;
  const sortDirection = externalSortDirection ?? internalSortDirection;

  const handleSort = (field) => {
    if (onSort) {
      onSort(field);
      return;
    }

    if (sortField === field) {
      setInternalSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setInternalSortField(field);
      setInternalSortDirection("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return faSort;
    return sortDirection === "asc" ? faSortUp : faSortDown;
  };

  const sortData = (dataToSort) => {
    if (!sortField) return dataToSort;

    return [...dataToSort].sort((a, b) => {
      let aVal = a[sortField] ?? "";
      let bVal = b[sortField] ?? "";

      if (typeof aVal === "string") {
        return sortDirection === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
    });
  };

  const sortedData = sortData(data);

  if (!sortedData || sortedData.length === 0) {
    return (
      <div className="table-responsive">
        <div className="no-data">{emptyMessage}</div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                onClick={() => col.sortable && handleSort(col.key)}
                style={{ cursor: col.sortable ? "pointer" : "default" }}
              >
                {col.label}
                {col.sortable && (
                  <FontAwesomeIcon icon={getSortIcon(col.key)} />
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row, index) => (
            <tr
              key={row._id || index}
              className={rowClassName ? rowClassName(row) : ""}
            >
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row) : (row[col.key] ?? "-")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
